export default {
	props: {
		nextRoute: {
			type: String,
			default: 'settings'
		},
		backRoute: {
			type: String,
			default: 'settings'
		}
	},
	methods: {
		next() {
			this.navigate({ name: this.nextRoute }, 'forward')
		},
		back() {
			this.navigate({ name: this.backRoute }, 'back')
		}
	}
}
